import { createAsyncThunk } from "@reduxjs/toolkit";
import Sessions from "utils/Sessions";
import ApiService from "../ApiService/ApiService";

export const getCibilScore = createAsyncThunk("get-cibil/score", async (id) => {
  const res = await ApiService.get(`loan/cibil/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

const fetchCibilScore = createAsyncThunk("fetch-cibil/score", async (data) => {
  const res = await ApiService.post(
    `loan/cibil`,
    { ...data.body },
    {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    }
  )
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

// Withut formid
const fetchCibil = createAsyncThunk("fetch-cibil/score-without-form-id", async (data) => {
  const res = await ApiService.post(
    `cibil`,
    { ...data.body },
    {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    }
  )
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export { fetchCibilScore, fetchCibil };
